import React from 'react'
import { GlobalStyles } from 'styles/GlobalStyles'
import { AllPages } from 'components/pages/AllPages'

export const App = () => {
  return (
    <>
      <GlobalStyles />
      <AllPages />
    </>
  )
}
